import { makeStyles } from 'tss-react/mui';

import { chipClasses } from '@mui/material';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Templates' })((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 8
        }
    },
    chip: {
        height: 34,
        borderRadius: 50,
        padding: '0 12px',
        background: 'rgba(255, 255, 255, 0.10) !important',
        border: '1px solid rgba(255, 255, 255, 0.15)',
        boxShadow: 'none !important',
        backdropFilter: 'blur(10px)',
        '@media (hover: hover)': {
            ['&:hover']: {
                background: 'rgba(255, 255, 255, 0.25) !important'
            }
        },
        ['&:active']: {
            background: 'transparent !important'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: '0 12px',
            height: 26
        },
        [`& .${chipClasses.label}`]: {
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            color: '#fff',
            fontSize: 16,
            fontWeight: 500,
            [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
                fontSize: 12
            }
        }
    },
    arrow: {
        transition: 'all 0.2s',
        transform: 'rotate(0deg)',
        width: 16,
        height: 16
    },
    _rotated: {
        transform: 'rotate(180deg)'
    }
}));
